import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'edit_order' */ './EditOrder'),
);
